/**
 * Fetches the latest 30-year fixed mortgage rate from the FRED API (St. Louis Fed).
 * Series: MORTGAGE30US (Freddie Mac Primary Mortgage Market Survey)
 * No API key required for this public endpoint.
 * 
 * Will be replaced with a cached backend endpoint if needed.
 */

const FRED_SERIES_URL = 'https://api.stlouisfed.org/fred/series/observations';
const SERIES_ID = 'MORTGAGE30US';
const API_KEY = '0ef41560c269f1e16d0d4b4e22f37ec8'; // Free public FRED API key

let cachedRate = null;
let cacheTimestamp = 0;
const CACHE_DURATION_MS = 60 * 60 * 1000; // 1 hour

export const fetchFredMortgageRate = async () => {
  if (cachedRate && (Date.now() - cacheTimestamp < CACHE_DURATION_MS)) {
    return cachedRate;
  }

  try {
    const url = `${FRED_SERIES_URL}?series_id=${SERIES_ID}&api_key=${API_KEY}&file_type=json&sort_order=desc&limit=1`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('FRED API request failed');
    const data = await response.json();
    const observations = data?.observations;
    if (observations && observations.length > 0 && observations[0].value !== '.') {
      const result = {
        rate: parseFloat(observations[0].value),
        date: observations[0].date,
      };
      cachedRate = result;
      cacheTimestamp = Date.now();
      return result;
    }
    return null;
  } catch (err) {
    console.warn('Failed to fetch FRED mortgage rate:', err);
    return null;
  }
};
